
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-2c7e89d2\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=styles&index=0!./TcColorPicker.vue")

var Component = require("!../../../../../../../shared/frontend/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./TcColorPicker.vue"),
  /* template */
  require("!!../../../../../../../shared/frontend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2c7e89d2\"}!../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=template&index=0!./TcColorPicker.vue"),
  /* scopeId */
  "data-v-2c7e89d2",
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/releases/136/frontend/src/views/Techcenter/components/TcColorPicker.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TcColorPicker.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c7e89d2", Component.options)
  } else {
    hotAPI.reload("data-v-2c7e89d2", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Techcenter/components/TcColorPicker.vue
// module id = 977
// module chunks = 1